// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"147":"e2de2021","246":"9ce635e6"}[chunkId] + ".css";
};